/**
 * @(#)2021/6/21.
 * YxHocTreeSelect，树选择,antd 3.x 版本增加 dropdownRender 对下拉菜单进行自由扩展
 * @author bobi
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React, { Component } from "react";
import ReactDOM, { findDOMNode } from "react-dom";
import { TreeSelect } from "antd";
import { omit } from "lodash";
function setStyle(ele, styPorps) {
  for (var key in styPorps) {
    ele.style[key] = styPorps[key];
  }
}
function YxHocTreeSelect(Com) {
  return class extends Component {
    instanRef = React.createRef();
    dropdownClassName =
      "yx-select-dropdown-" + Math.floor(Math.random() * 1000);
    isbool = false;
    dropdownRender() {
      if (this.isbool) return;

      let { dropdownRender, dropdownStyle } = this.props;
      if (dropdownRender && typeof dropdownRender === "function") {
        setTimeout(() => {
          let dropdownRef = document.querySelector(
            `.${this.dropdownClassName}`
          );
          if (!dropdownRef) return;
          this.isbool = dropdownRef ? true : false;
          setStyle(dropdownRef.firstChild, dropdownStyle);
          let addRef = document.createElement("div");
          addRef.className = "yx-treeSelect-dropdown-footer";
          setStyle(addRef, {
            padding: "6px",
            borderTop: "1px solid #eee",
            background: "#f4f4f4",
          });
          dropdownRef.appendChild(addRef);
          ReactDOM.render(dropdownRender(this.props), addRef);
          // ReactDOM.createPortal(dropdownRender(this.props), addRef);
        }, 300);
      }
    }
    componentDidMount() {
      if (!this.props.dropdownRender) return; // 如果不存在该参数，不需要执行该插入节点操作
      let rootRef = findDOMNode(this);
      let inputRef = rootRef.querySelector(".ant-select-search__field");
      if (inputRef) {
        inputRef.addEventListener(
          "focus",
          () => {
            this.dropdownRender();
          },
          false
        );
      }
    }
    render() {
      let {
        dropdownRender,
        dropdownClassName = "",
        children,
        ...newProps
      } = this.props;
      if (dropdownRender) {
        newProps = omit(newProps, ["dropdownStyle"]);
      }

      return (
        <Com
          dropdownClassName={`${dropdownClassName} ${this.dropdownClassName}`}
          {...newProps}
        >
          {children}
        </Com>
      );
    }
  };
}
export default YxHocTreeSelect(TreeSelect);



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxHoTreeSelect.js